// import { BiArchiveOut } from "react-icons/bi";
// import React, { useState } from "react";
// import { CardWrapper, ThreeDotsContainer, UpdateIcon } from "./style";
// import { FiMoreVertical } from "react-icons/fi";
// import img from "../../../assets/icons/calendard.svg";

// function CategoryCard({ data, onAchive, noaction }) {
//   const [open, setOpen] = useState(false);
//   return (
//     <div>
//       <CardWrapper>
//         <div className="card-header">
//           <h2 className="title truncate-text">{data.title}</h2>
//           <div className="header">
//             <FiMoreVertical
//               className="three-dots"
//               onClick={() => (open ? setOpen(false) : setOpen(true))}
//             />
//           </div>

//           {noaction ? null : (
//             <>
//               {open && (
//                 <ThreeDotsContainer
//                   onMouseOver={() => setOpen(true)}
//                   onMouseOut={() => setOpen(false)}
//                 >
//                   <UpdateIcon onClick={() => onAchive(data?.id)}>
//                     <BiArchiveOut size={13} className="editicon" />
//                     Arxivlash
//                   </UpdateIcon>
//                 </ThreeDotsContainer>
//               )}
//             </>
//           )}
//         </div>
//         {data.date ? (
//           <>
//             <div className="footer">
//               <div className="foterNum">
//                 <h1 className="num">{data.count}</h1>
//                 <p className="nafar">nafar</p>
//               </div>
//               <h3 className="date">
//                 <img src={img} alt="" />
//                 {data.date}
//               </h3>
//             </div>
//           </>
//         ) : (
//           <h1 className="num">{data.count}</h1>
//         )}
//       </CardWrapper>
//     </div>
//   );
// }

// export default CategoryCard;

import React, { useState } from 'react';
import {
  CardWrap,
  Header,
  Footer,
  ThreeDotsContainer,
  UpdateIcon,
} from './style';
import img from '../../../assets/icons/file-06.svg';
import cloc from '../../../assets/icons/clock.svg';
import calendar from '../../../assets/icons/calendar.svg';
import { FiMoreVertical } from 'react-icons/fi';
import { BiArchiveOut } from 'react-icons/bi';

function Message({ data, notFunc, onAchive, noaction }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <CardWrap>
        <Header>
          <div>
            {data?.date ? (
              <h2>{data?.title}</h2>
            ) : (
              <>
                <h2 className='category'>{data?.category}</h2>
                <h2 className='name'>{data?.title}</h2>
              </>
            )}
            <p>{data?.phone}</p>
            {data?.vacancy ? (
              <div className='vacancy'>
                <span>Vakansiya:</span> {data?.vacancy?.title}
              </div>
            ) : null}
          </div>
          <div className='header'>
            {notFunc ? (
              <FiMoreVertical className='three-dots' />
            ) : (
              <FiMoreVertical
                className='three-dots'
                onClick={() => (open ? setOpen(false) : setOpen(true))}
              />
            )}
          </div>
          {noaction ? null : (
            <>
              {open && (
                <ThreeDotsContainer
                  onMouseOver={() => setOpen(true)}
                  onMouseOut={() => setOpen(false)}
                >
                  <UpdateIcon onClick={() => onAchive(data?.id)}>
                    <BiArchiveOut
                      size={13}
                      className='editicon'
                    />
                    Arxivlash
                  </UpdateIcon>
                </ThreeDotsContainer>
              )}
            </>
          )}
        </Header>
        <Footer>
          {data?.date ? (
            <>
              <div>
                <div className='date-title'>Bog‘lanish sanasi</div>
                <div className='date'>
                  <img
                    src={calendar}
                    alt=''
                  />{' '}
                  {data?.date}
                </div>
              </div>
              <div>
                <div className='date-title'>Bog‘lanish vaqti</div>
                <div className='date'>
                  <img
                    src={cloc}
                    alt=''
                  />
                  {data?.hour}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className='rezume'>Rezume:</div>
              <a
                href={data?.file ?? ''}
                target='_blank'
                rel='noopener noreferrer'
              >
                <div className='rezume-icon'>
                  <img
                    src={img}
                    alt=''
                  />
                </div>
              </a>
            </>
          )}
        </Footer>
      </CardWrap>
    </div>
  );
}

export default Message;